import { MARK_SUPERSCRIPT } from '@udecode/plate-basic-marks';

export const SUPERSCRIPT_PLUGIN_KEY = MARK_SUPERSCRIPT;
export const SUPERSCRIPT_TYPE = 'uui-richTextEditor-superscript';
